module.exports = __webpack_public_path__ + "static/media/App.d1ffc271.png";